



































import { defineComponent, getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/composition-api";
import useCountDown from "@/hooks/useCountDown";
import { EVENTS } from "@/lib/const";
import emitter from "@/lib/helpers/emitter";
import providers from "@/lib/providers";
import { $t } from "@/lib/helpers/i18nHelper";
import { FormField } from "@/types";
import FieldPrinter from "@/components/FieldPrinter";
import config from "./config";

export default defineComponent({
  name: "PageForgotPasswordConfirmCode",
  props: {
    email: { type: String, default: "" },
  },
  components: {
    FieldPrinter,
  },
  setup(props) {
    const token = ref("");
    const code = ref("");
    const valid = ref(true);
    const processing = ref(false);
    const vm = getCurrentInstance();

    const { timeLeft, start, stop, restart } = useCountDown(config.timeoutInSeconds);
    onMounted(start);
    onUnmounted(stop);
    emitter.emit(EVENTS.LOADING.CHANGE, false);

    const fieldCode: FormField = {
      name: "code",
      title: $t("Verification code"),
      rules: [(v: string) => !!v || $t("Verification code is required")],
    };

    const codeResend = async () => {
      if (processing.value) return;
      try {
        processing.value = true;
        restart();
        await providers.PasswordResetProvider.start({ data: { email: props.email } });
      } finally {
        processing.value = false;
      }
    };
    const submit = async () => {
      if (!code.value) {
        alert("Enter verification code");
        return;
      }
      try {
        emitter.emit(EVENTS.LOADING.CHANGE, true);

        let data = await providers.PasswordResetProvider.verify({ data: { code: code.value, email: props.email } });
        token.value = data?.token ?? "";
        if (token.value) {
          vm?.$router.push({
            name: "loginForgotSet",
            params: { email: props.email, token: token.value },
          });
        }
      } finally {
        emitter.emit(EVENTS.LOADING.CHANGE, false);
      }
    };

    return {
      token,
      timeLeft,
      code,
      fieldCode,
      valid,
      codeResend,
      submit,
    };
  },
});
